import type { TValidIrrigationSchedulerZoneEmitterId } from 'stores/fieldAssetStore/helperTypes'

export const isValidIrrigationSchedulerZoneEmitterId = (
  id: string,
): id is TValidIrrigationSchedulerZoneEmitterId => {
  const parts = id.split('|||')

  if (parts.length !== 2) return false

  const [numberPart, emitterTypePart] = parts
  const num = Number(numberPart)

  if (isNaN(num) || num.toString() !== numberPart) return false

  return typeof emitterTypePart === 'string' && emitterTypePart.startsWith('emitter-')
}
